import { Badge } from '../../shared/ui/Badge.js';
import './analysis-freshness.css';

/**
 * Dates the figures with the last completed analysis run (bug 2, R0.6). The
 * Console reads aggregates, never raw events, so an engine that stopped looks
 * exactly like an absence of traffic — this is what tells the two apart.
 */
const HOUR_MS = 3_600_000;
/** The pipeline loops hourly; past two hours a run has been missed. */
const STALE_AFTER_MS = 2 * HOUR_MS;

export function AnalysisFreshness({ lastAnalysisAt }: { lastAnalysisAt: string | null | undefined }) {
  if (lastAnalysisAt === undefined) return null;

  if (lastAnalysisAt === null) {
    return (
      <span className="freshness" title="Le moteur d'analyse n'a encore produit aucun passage.">
        <Badge tone="warning">Analyse jamais exécutée</Badge>
      </span>
    );
  }

  const at = new Date(lastAnalysisAt);
  const elapsed = Date.now() - at.getTime();
  const stale = elapsed > STALE_AFTER_MS;
  const stamp = at.toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' });

  return (
    <span
      className="freshness"
      title={`Dernier passage du moteur d'analyse : ${at.toLocaleString('fr-FR')}. Les indicateurs ne bougent qu'à chaque passage.`}
    >
      {stale ? (
        <Badge tone="warning">Données arrêtées au {stamp}</Badge>
      ) : (
        <span className="freshness__text">Données au {stamp}</span>
      )}
    </span>
  );
}
